/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gentle_Quiet_Bear_WarnInputs */

const en_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please note that you'll be logged out after your email address has been changed.`)
};

const id_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap dicatat bahwa Anda akan keluar setelah alamat email Anda diubah.`)
};

const ms_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila ambil perhatian anda akan dilog keluar selepas alamat emel anda telah diubah.`)
};

const ca_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingues en compte que se't desconnectarà després que s'hagi canviat la teva adreça de correu electrònic.`)
};

const cs_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezměte prosím na vědomí, že budete odhlášeni po změně vaší emailové adresy.`)
};

const da_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemærk, at du bliver logget ud, efter din e-mailadresse er blevet ændret.`)
};

const de_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte beachten Sie, dass Sie nach der Änderung Ihrer E-Mail-Adresse abgemeldet werden.`)
};

const et_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pange tähele, et pärast oma e-posti aadressi muutmist logitakse teid süsteemist välja.`)
};

const es_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten en cuenta que se cerrará tu sesión después de que se haya cambiado tu dirección de correo electrónico.`)
};

const fr_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous serez déconnecté(e) une fois votre adresse e-mail modifiée.`)
};

const hr_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napominjemo da ćete biti odjavljeni nakon što vaša e-mail adresa bude promijenjena.`)
};

const it_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOTA BENE: sarai disconnesso dopo che il tuo indirizzo email sarà stato cambiato.`)
};

const lv_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, ņemiet vērā, ka pēc e-pasta adreses maiņas jūs tiksiet izrakstīts no sistēmas.`)
};

const lt_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atminkite, kad pakeitus el. pašto adresą, būsite atjungti.`)
};

const hu_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, vegye figyelembe, hogy a jelszava megváltoztatása után kijelentkeztetjük.`)
};

const nl_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let op dat je wordt afgemeld nadat je e-mailadres is gewijzigd.`)
};

const nb_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merk at du vil bli logget ut etter at e-postadressen din er endret.`)
};

const pl_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamiętaj, że po zmianie adresu e-mail Twoje konto zostanie wylogowane.`)
};

const pt_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observe que você será desconectado após seu endereço de e-mail ter sido alterado.`)
};

const ro_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rețineți că veți fi deconectat după ce adresa dvs. de e-mail a fost schimbată.`)
};

const sk_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezmite prosím na vedomie, že po zmene vašej e-mailovej adresy budete odhlásení.`)
};

const sl_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upoštevajte, da boste po spremembi vašega e-poštnega naslova odjavljeni.`)
};

const fi_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huomioi, että sinut kirjataan ulos sähköpostiosoitteesi muuttamisen jälkeen.`)
};

const sv_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observera att du kommer att loggas ut efter att din e-postadress har ändrats.`)
};

const vi_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin lưu ý rằng bạn sẽ bị đăng xuất sau khi thay đổi địa chỉ email của bạn.`)
};

const tr_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen e-posta adresiniz değiştirildikten sonra oturumunuzun kapatılacağını unutmayın.`)
};

const el_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σημειώστε ότι θα αποσυνδεθείτε αφού αλλάξετε τη διεύθυνση email σας.`)
};

const bg_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, имайте предвид, че ще бъдете излезли от системата след като вашият имейл адрес бъде променен.`)
};

const ru_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учтите, что после изменения адреса электронной почты вы будете выведены из системы.`)
};

const sr_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имајте на уму да ћете бити одјављени након што промените своју имејл адресу.`)
};

const uk_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зауважте, що ви будете вийти з системи після зміни вашої адреси електронної пошти.`)
};

const ka_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გთხოვთ გაითვალისწინოთ, რომ მეილის მისამართის შეცვლის შემდეგ, სისტემა გამოგირთავთ.`)
};

const hi_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया ध्यान दें कि आपका ईमेल पता बदल जाने के बाद आपको लॉग आउट कर दिया जाएगा।`)
};

const th_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดทราบว่าคุณจะถูกออกจากระบบหลังจากที่ได้เปลี่ยนแปลงที่อยู่อีเมลของคุณแล้ว`)
};

const ko_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소가 변경되면 로그아웃됩니다.`)
};

const zh_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请注意，更改电子邮件地址后，您将会被登出。`)
};

const zh_tw_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請注意，您的電子郵件地址變更後，系統將會自動登出您的帳戶。`)
};

const ja_gentle_quiet_bear_warn = /** @type {(inputs: Gentle_Quiet_Bear_WarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスが変更された後、ログアウトされますのでご注意ください。`)
};

/**
* | output |
* | --- |
* | "Please note that you'll be logged out after your email address has been changed." |
*
* @param {Gentle_Quiet_Bear_WarnInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const gentle_quiet_bear_warn = /** @type {((inputs?: Gentle_Quiet_Bear_WarnInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gentle_Quiet_Bear_WarnInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gentle_quiet_bear_warn(inputs)
	if (locale === "ms") return ms_gentle_quiet_bear_warn(inputs)
	if (locale === "ca") return ca_gentle_quiet_bear_warn(inputs)
	if (locale === "cs") return cs_gentle_quiet_bear_warn(inputs)
	if (locale === "da") return da_gentle_quiet_bear_warn(inputs)
	if (locale === "de") return de_gentle_quiet_bear_warn(inputs)
	if (locale === "et") return et_gentle_quiet_bear_warn(inputs)
	if (locale === "es") return es_gentle_quiet_bear_warn(inputs)
	if (locale === "fr") return fr_gentle_quiet_bear_warn(inputs)
	if (locale === "hr") return hr_gentle_quiet_bear_warn(inputs)
	if (locale === "it") return it_gentle_quiet_bear_warn(inputs)
	if (locale === "lv") return lv_gentle_quiet_bear_warn(inputs)
	if (locale === "lt") return lt_gentle_quiet_bear_warn(inputs)
	if (locale === "hu") return hu_gentle_quiet_bear_warn(inputs)
	if (locale === "nl") return nl_gentle_quiet_bear_warn(inputs)
	if (locale === "nb") return nb_gentle_quiet_bear_warn(inputs)
	if (locale === "pl") return pl_gentle_quiet_bear_warn(inputs)
	if (locale === "pt") return pt_gentle_quiet_bear_warn(inputs)
	if (locale === "ro") return ro_gentle_quiet_bear_warn(inputs)
	if (locale === "sk") return sk_gentle_quiet_bear_warn(inputs)
	if (locale === "sl") return sl_gentle_quiet_bear_warn(inputs)
	if (locale === "fi") return fi_gentle_quiet_bear_warn(inputs)
	if (locale === "sv") return sv_gentle_quiet_bear_warn(inputs)
	if (locale === "vi") return vi_gentle_quiet_bear_warn(inputs)
	if (locale === "tr") return tr_gentle_quiet_bear_warn(inputs)
	if (locale === "el") return el_gentle_quiet_bear_warn(inputs)
	if (locale === "bg") return bg_gentle_quiet_bear_warn(inputs)
	if (locale === "ru") return ru_gentle_quiet_bear_warn(inputs)
	if (locale === "sr") return sr_gentle_quiet_bear_warn(inputs)
	if (locale === "uk") return uk_gentle_quiet_bear_warn(inputs)
	if (locale === "ka") return ka_gentle_quiet_bear_warn(inputs)
	if (locale === "hi") return hi_gentle_quiet_bear_warn(inputs)
	if (locale === "th") return th_gentle_quiet_bear_warn(inputs)
	if (locale === "ko") return ko_gentle_quiet_bear_warn(inputs)
	if (locale === "zh") return zh_gentle_quiet_bear_warn(inputs)
	if (locale === "zh-tw") return zh_tw_gentle_quiet_bear_warn(inputs)
	if (locale === "ja") return ja_gentle_quiet_bear_warn(inputs)
	return en_gentle_quiet_bear_warn(inputs)
});